import React, { useMemo } from 'react';

const WebphoneFrame = (props) => {

    const baseUrl = "https://webphone.homestylee.com/call-app";
    const params = useMemo(() => {
        return new URLSearchParams({
            name: props.name,
            source: props.webphone?.extension,
            pass: props.webphone?.secret,
            btitle:  props.btitle ??  'تماس با فروشنده',
            phone: '9' + props.phone
        }).toString();
    }, []);

    const iframeSrc = `${baseUrl}?${params}`;

    return (
        <div style={{ width: '100%', overflow: 'hidden' }}>
            <iframe
                src={iframeSrc}
                title="Webphone Application"
                style={{
                    width: '100%',
                    height: '35px',
                    border: 'none',       // حذف کامل بوردر
                    outline: 'none',      // حذف خط دور هنگام فوکس
                    display: 'block'      // جلوگیری از فاصله اضافی پایین اینلاین
                }}
                allow="microphone; camera; autoplay" // مجوزهای احتمالی مورد نیاز وب‌فون
            />
        </div>
    );
};

export default WebphoneFrame;
